
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import { brand } from '../../config/brand';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.mode === 'light'
          ? 'rgba(255, 255, 255, 0.7)'
          : 'rgba(18, 18, 18, 0.7)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid',
        borderColor: (theme) => theme.palette.mode === 'light'
          ? 'rgba(0, 0, 0, 0.08)'
          : 'rgba(255, 255, 255, 0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              {brand.productName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              A multi-agent, multi-interface AI system that builds secure, production-ready code with fast deployment.
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Resources
            </Typography>
            <Link href={brand.links.hostedChat} target="_blank" rel="noopener" color="inherit" display="block" sx={{ mb: 1 }}>
              Try it in your browser
            </Link>
            <Link component={RouterLink} to="/docs" color="inherit" display="block" sx={{ mb: 1 }}>
              Documentation
            </Link>
            <Link component={RouterLink} to="/training" color="inherit" display="block" sx={{ mb: 1 }}>
              Video tutorials
            </Link>
            <Link component={RouterLink} to="/gallery" color="inherit" display="block" sx={{ mb: 1 }}>
              Examples
            </Link>
            <Link component={RouterLink} to="/pricing" color="inherit" display="block" sx={{ mb: 1 }}>
              Pricing
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Company
            </Typography>
            <Link component={RouterLink} to="/about" color="inherit" display="block" sx={{ mb: 1 }}>
              About Us
            </Link>
            <Link component={RouterLink} to="/contact" color="inherit" display="block" sx={{ mb: 1 }}>
              Contact
            </Link>
            <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" display="block" sx={{ mb: 1 }}>
              Terms of Service
            </Link>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3 }} />
        
        <Box textAlign="center">
          <Typography variant="body2" color="text.secondary">
            © {currentYear} {brand.productName} by Loxia. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
